module.exports = __webpack_public_path__ + "img/notebook-check-outline-gray.2e6afc76.svg";